<template>
    <div id="journal">
        <Banner title="會刊及影音" :breadcrumbs="breadcrumbs" type="information"></Banner>
        <div class="container">
            <div class="center_title">
                <Title en="Journals" chtFirst="會刊" chtSecond="資訊" :center="true"></Title>
            </div>
            <div class="remark" v-if="!islogin">提醒您!若想下載會刊資料，必須是付費會員，謝謝!</div>
            <section
                class="pdflist"
                v-infinite-scroll="loadMore"
                infinite-scroll-disabled="busy"
                infinite-scroll-distance="10"
            >
                <div class="item" v-for="(pdf,index) in pdfs" :key="index">
                    <PDFcard :data="pdf" :islogin="islogin"></PDFcard>
                </div>
            </section>
        </div>
        <loading v-if="isLoading"></loading>
    </div>
</template>

<script>
import PDFcard from "@/components/information/imgbtnCard";
import API from "@/service/conference";
export default {
    name: "journal",
    components: {
        PDFcard
    },
    props: {
        islogin: {
            type: Boolean
        },
        journals: {
            type: String
        }
    },
    data() {
        return {
            breadcrumbs: [
                {
                    url: "/",
                    title: "首頁"
                },
                {
                    title: "會刊及影音"
                },
                {
                    url: "/Conference/Journals",
                    title: "會刊資訊"
                }
            ],
            pdfs: [],
            busy: false,
            nowPage: 1,
            totalPage: 1,
            isLoading: false
        };
    },
    methods: {
        loadMore() {
            const vm = this;
            vm.busy = true;
            if (vm.totalPage == 1 || vm.totalPage == vm.nowPage) {
                return false;
            }
            vm.isLoading = true;
            vm.nowPage += 1;
            API.getJournalList({ page: vm.nowPage, count: 10 }).then(result => {
                if (result.Data.Journals.length === 0) {
                    return false;
                } else {
                    setTimeout(function() {
                        vm.busy = false;
                    }, 1000);
                }
                setTimeout(function() {
                    vm.isLoading = false;
                }, 500);
                let JournalList = result.Data.Journals;
                vm.pdfs = vm.pdfs.concat(JournalList);
            });
        }
    },
    computed: {},
    created() {
        const vm = this;
        if (vm.journals) {
            // API.getJournalList({ page: 1, count: 999 }).then(res => {
            //   if (res.Ok) {
            //     vm.pdfs = res.Data.Journals;
            //   }
            // });
            let obj = JSON.parse(vm.journals);
            vm.pdfs = obj.Journals;
            // console.log(vm.pdfs);
            vm.totalPage = Math.ceil(parseInt(obj.Total) / 10);
        } else {
            vm.pdfs = [
                {
                    Id: "awdasd312",
                    Number: "第五期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img2.png"),
                    StartOn: "2019-01-01",
                    EndOn: "2019-02-13",
                    DocumentFile: "../../static/pdf/pdf01.pdf"
                },
                {
                    Id: "234sdfhd",
                    Number: "第四期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img3.png"),
                    StartOn: "2019-01-01",
                    EndOn: "2019-02-13",
                    DocumentFile: "../../static/pdf/pdf03.pdf"
                },
                {
                    Id: "asd455467f",
                    Number: "第三期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img4.png"),
                    StartOn: "2019-01-01",
                    EndOn: "2019-02-13",
                    DocumentFile: "../../static/pdf/pdf03.pdf"
                },
                {
                    Id: "768dfgs344r",
                    Number: "第二期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img3.png"),
                    StartOn: "2019-01-01",
                    EndOn: "2019-02-13",
                    DocumentFile: "../../static/pdf/pdf03.pdf"
                },
                {
                    Id: "das43654",
                    Number: "第一期",
                    Title:
                        "青光眼濾泡手術相關眼內炎南台灣醫學中心的回朔性病例分析",
                    Image: require("@/assets/dev/img4.png"),
                    StartOn: "2019-01-01",
                    EndOn: "2019-02-13",
                    DocumentFile: "../../static/pdf/pdf03.pdf"
                }
            ];
        }
    },
    mounted() {
        const vm = this;
    },
    watch: {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#journal .remark {
    margin-bottom: 30px;
    text-align: center;
}
#journal .pdflist {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    margin-bottom: 60px;
    align-items: stretch;
}
#journal .pdflist::after {
    content: "";
    flex: 0 0 30%;
    width: 30%;
    max-width: 350px;
}
#journal .pdflist .item {
    width: 30%;
    max-width: 350px;
    margin-bottom: 25px;
}
@media screen and (max-width: 992px) {
    #journal .pdflist .item {
        width: 48%;
        max-width: none;
    }
}
@media screen and (max-width: 767px) {
    #journal .pdflist .item {
        width: 100%;
        max-width: none;
        margin: 0 auto 30px;
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/journal.vue